import { render, staticRenderFns } from "./RelatorioRupturaList.vue?vue&type=template&id=024f59c4&scoped=true"
import script from "./RelatorioRupturaList.vue?vue&type=script&lang=js"
export * from "./RelatorioRupturaList.vue?vue&type=script&lang=js"
import style0 from "./RelatorioRupturaList.vue?vue&type=style&index=0&id=024f59c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024f59c4",
  null
  
)

export default component.exports